import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import {
  checkPiAnswer,
  pick,
  range,
  renderPiAnswer,
  renderPiUserAnswer,
  SolidPiInput,
} from "./commonSolidPi";

export function generateTask() {
  const radius = pick(range(2, 8));
  const height = pick([3, 6, 9, 12]);
  const cylinderK = radius * radius * height;
  const coneK = cylinderK / 3;
  const direction = Math.random() < 0.5 ? "coneFromCylinder" : "cylinderFromCone";
  const answerK = direction === "coneFromCylinder" ? coneK : cylinderK;

  return {
    type: "CylinderConeVolumeComparisonTask",
    data: { radius, height, cylinderK, coneK, direction, answerK, numeric: answerK * Math.PI },
  };
}

export function renderTask({ data }) {
  const asksForCone = data.direction === "coneFromCylinder";
  const givenK = asksForCone ? data.cylinderK : data.coneK;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>
        Walec i stożek mają takie same podstawy oraz takie same wysokości.
        Objętość {asksForCone ? "walca" : "stożka"} wynosi{" "}
        <InlineMath math={`${givenK}\\pi`} />.
      </p>
      <p>Oblicz objętość {asksForCone ? "stożka" : "walca"}.</p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return <SolidPiInput value={userAnswer} onChange={onChange} disabled={disabled} label="V" />;
}

export function checkAnswer({ data }, userAnswer) {
  return checkPiAnswer(data.numeric, userAnswer);
}

export function renderAnswer({ data }) {
  return renderPiAnswer("V", data.answerK);
}

export function renderUserAnswer(userAnswer) {
  return renderPiUserAnswer(userAnswer, "V");
}

export function renderExplanation({ data }) {
  const asksForCone = data.direction === "coneFromCylinder";
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1.</strong> Przy tych samych podstawach i wysokościach
        objętość stożka jest trzy razy mniejsza od objętości walca.
      </p>
      <BlockMath math={String.raw`V_{\text{stożka}}=\frac13V_{\text{walca}}`} />
      <p><strong>Krok 2.</strong> Podstawiamy podaną objętość.</p>
      {asksForCone ? (
        <BlockMath math={`V_{\\text{stożka}}=\\frac13\\cdot${data.cylinderK}\\pi=${data.coneK}\\pi`} />
      ) : (
        <BlockMath math={`V_{\\text{walca}}=3\\cdot${data.coneK}\\pi=${data.cylinderK}\\pi`} />
      )}
    </div>
  );
}
